import { useRef, useCallback } from 'react';
import { debounce } from 'lodash';
import { useFormikContext, FormikContextType, FormikProps } from 'formik';
import useDeepCompareEffect from 'use-deep-compare-effect';

interface Props<V> {
  disableOnChange?: boolean;
  onChange: (formik: FormikContextType<V>) => void;
}

export default function FormikEffect<V>(props: Props<V>) {
  const { onChange, disableOnChange = false } = props;
  const formik: FormikProps<V> = useFormikContext<V>();
  const isFirstRun = useRef(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedOnChange = useCallback(debounce(onChange, 200), []);

  useDeepCompareEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;

      return;
    }

    !disableOnChange && debouncedOnChange(formik);
  }, [formik]);

  return null;
}
